import React, { useEffect, useState } from 'react';
import {CSSTransition} from 'react-transition-group';
import i18n from '../../utils/i18n';
import connect from '../../../js_bytesize/config/purchase/connect';
import Config from '../../../js_bytesize/config/purchase/config';
import Styled from 'styled-components';
import {fontQuicksand} from './mixin';
import { computePricingInfo, amountInLocalCurrency, melaDurationMap, subjectCodeMap, currencyCode} from '../../../js_bytesize/templates/purchase/pricing-helper';
import { device } from '../../utils/responsive_utilities';
import GTMScript from "../../utils/gtm-script";
import { buildStripeErrorPayloads, buildPurchaseFormErrorPayload } from '../../utils/stripe-analytics-helper';
import GetAdditionalElaImage from '~images/mela-purchase/getadditional-ela.svg';
import GetAdditionalMathImage from '~images/mela-purchase/getadditional-math.svg';
import SavePiggybankImage from '~images/mela-purchase/save-piggybank.svg';

import TrialInfo from './trial';
import GameCount from './game-count';
import ProductPlan from './plan';
import FilterTab from './filter-tab';
import PurchaseCta from './purchase-cta';
import PreferredPlanModal from './preferred-plan-modal';
import CreditCardsContainer from './credit-card-container';
import MoneyBackWidget from './money-back-strip';
import { getABTestValue } from '../../utils/ab-tests';
import PaymentRequestButton from './payment-request-button';

import { getStripePromise } from '../../utils/web-helper';

import { Elements } from '@stripe/react-stripe-js';
import { showMBG } from '../../utils/web-helper';
import ConfigurePayment from './configure-payment';
import {PAYMENT_ELEMENT_SOURCE} from './payment-element/config';

import { PARENTPTL_NEW_SIGNUPS_DISCOUNT_CODE } from '../../constant-data/constants';
import { breakpoints } from '../../utils/responsive_utilities';
import {isPaymentElementEnabled} from '../../utils/feature_mapping';

const monthlyPlan = 'monthly';

function Plans({
  products,
  productLists,
  activeFilterTab,
  filterTabList,
  filterTabHandler,
  productsBySubject,
  settings,
  purchaseCompleteMethod,
  studentId,
  upgradeAble,
  restrictionInfoStore,
  sendAnalytics,
  sortedDurationList,
  preferredPlanSaving,
  skipSignUp,
  fromTrial,
  paymentSuccessHandlerForSVTrial,
  redirectUrl,
  parentDobYear,
  ptlParent,
  showDiscountChanges,
  timeLeft,
  stripePaymentElement,
  updateProductPurchaseContext,
  currentPlan
  }) {
  let DEFAULT_PLAN_DURATION = sortedDurationList[0];

  const [initialDuration, setInitialDuration] = useState(DEFAULT_PLAN_DURATION);
  const [showMorePlans, setShowMorePlans] = useState(Number(localStorage.getItem("discount_timer")) > 0 ? false : settings.show_combined_landing_page_for_plan_page);
  const [selectedBox, selectedBoxHandler] = useState(products.get(initialDuration));
  const [selectedPlan, selectedPlanHandler] = useState({});
  const [showModal, modalHandler] = useState(false);
  const [selectedPlanName, setSelectedPlanName] = useState(DEFAULT_PLAN_DURATION);
  const [error, setError] = useState(null);
  const [savePercentage, setSavePercentage] = useState(null);
  const [percentOffAmount, setPercentOffAmount] = useState(null);
  const [preferrPlanModalContent,setPreferrPlanModalContent] = useState(null);
  const [paymentRequest, setPaymentRequest] = useState(null);


  const [stripe, setStripe] = useState(null);
  let modifiedSettings = {...settings}
  
  const paymentRequestElementOptions = modifiedSettings?.payment_request_element_options;
  modifiedSettings=!showDiscountChanges && modifiedSettings.coupon && modifiedSettings.coupon.stripe_id===PARENTPTL_NEW_SIGNUPS_DISCOUNT_CODE ? {...settings,coupon:null,couponRedeemable:null} : {...settings}
  let {properties={}, access_duration} = selectedPlan;
  let {actualPrice=0,
    discountedPrice=0,
    discountedMonthlyPrice=0,
    percentOff=null} = Object.keys(selectedPlan).length ? computePricingInfo(selectedPlan, modifiedSettings) : {};

  let showFilter = productsBySubject.has('mela');
  let subjectsLength = productsBySubject.size;
  const shorterDurationProduct = products.get(sortedDurationList[sortedDurationList.length - 1])[0];
  let defaultShorterPlanDuration = shorterDurationProduct && melaDurationMap[shorterDurationProduct["access_duration"]]
  let userLandsOnAllPlansPage = modifiedSettings.show_combined_landing_page_for_plan_page;
  let StripePaymentElementEnabled = isPaymentElementEnabled(settings);
  // --------
  const frequencyLiterals =
    {
      300: `5 minutes`,
      600: `10 minutes`,
      900: `15 minutes`,
      3600:`hour`,
      86400: `day`,
      2592000: `month`,
      4838400: `2 month`,
      7884000: `quarter`,
      15768000: `half-year`,
      31536000: `year`,
      63072000: `2 year`,
      3156000000: `lifetime`
    };

  useEffect(()=>{
    if(showMorePlans){
      trackAnalyticsEvent('Visited All Plans Page',{});
    }
  },[showMorePlans])

  useEffect(() => {
    if (stripePaymentElement) {
      const currentProduct = JSON.parse(localStorage.getItem('selectedProduct'))
      const currentActiveFilterTab = JSON.parse(localStorage.getItem('activeFilterTab'))
      filterTabHandler(currentActiveFilterTab)
      selectedBoxHandler([currentProduct])
      selectedPlanHandler(currentProduct)
      setSelectedPlanName(currentProduct.properties.title0)
      setInitialDuration(melaDurationMap[currentProduct.access_duration])
      setShowMorePlans(false)
    }
  },[stripePaymentElement])

  useEffect(()=>{
    if (stripePaymentElement) {
      return;
    }
    selectedBoxHandler(products.get(DEFAULT_PLAN_DURATION));
    setInitialDuration(DEFAULT_PLAN_DURATION);
    setSelectedPlanName(DEFAULT_PLAN_DURATION);
    localStorage.setItem('activeFilterTab', JSON.stringify(activeFilterTab))
  },[activeFilterTab])

  useEffect(()=>{
    if (stripePaymentElement) {
      return;
    }
    selectedBox.find((val)=>{
      if(val.properties.title0===selectedPlanName && (melaDurationMap[val.access_duration] === selectedPlanName)) {
        localStorage.setItem('selectedProduct', JSON.stringify(val));
        selectedPlanHandler(val);
      }
    })
  },[selectedBox])

  useEffect(()=>{
    if(!showDiscountChanges && modifiedSettings.coupon && modifiedSettings.coupon.stripe_id===PARENTPTL_NEW_SIGNUPS_DISCOUNT_CODE){
      modifiedSettings= {...settings,coupon:null,couponRedeemable:null} 
    }
    
    if(sortedDurationList.length > 1 && Object.keys(selectedPlan).length) {
        let yearlyPriceInfo = null;
        let preferrPlanModalContent = {};
        let saveAmount = null, savePercentage = null;
        if(initialDuration === defaultShorterPlanDuration) {
          let yearlyPlanProduct = products.get(DEFAULT_PLAN_DURATION)[0];
          yearlyPriceInfo = computePricingInfo(yearlyPlanProduct, modifiedSettings);

        } else {
          yearlyPriceInfo = computePricingInfo(selectedPlan, modifiedSettings);
        }
        let quarterlyPlanProduct = products.get(sortedDurationList[1])[0];
        let quarterlyPriceInfo = computePricingInfo(quarterlyPlanProduct, modifiedSettings);
        let savePercent = Math.floor(Math.abs(((yearlyPriceInfo.actualMonthlyPrice/quarterlyPriceInfo.actualMonthlyPrice)-1)*100));
        setSavePercentage(savePercent);
        setPercentOffAmount(yearlyPriceInfo.percentOff);
        if(filterTabList.length === 3){
          if(initialDuration === "Yearly" && ((selectedPlan.feature_codes && selectedPlan.feature_codes.length != 2) || (selectedPlan.product_features && selectedPlan.product_features.length != 2))){ // Case-1 When User selects the Math or Reading Yearly or Family plan instead of Math + Reading Yearly or Family plan
            if(selectedPlanName === "Yearly"){
              let melaYearlyProduct = productsBySubject.get("mela").get("Yearly").find(p => p.properties.title0 === "Yearly")
              let melaYearlyPrice = (computePricingInfo(melaYearlyProduct, modifiedSettings).actualPrice/100.00).toFixed(2)
              let mathYearlyProduct =  productsBySubject.get("math").get("Yearly").find(p => p.properties.title0 === "Yearly")
              let mathYearlyPrice = (computePricingInfo(mathYearlyProduct, modifiedSettings).actualPrice/100.00).toFixed(2)
              saveAmount = (melaYearlyPrice - mathYearlyPrice).toFixed(0)
            }else{
              let melaFamilyProduct = productsBySubject.get("mela").get("Yearly").find(p => p.properties.title0 === "family")
              let melaFamilyPrice = (computePricingInfo(melaFamilyProduct, modifiedSettings).actualPrice/100.00).toFixed(2)
              let mathFamilyProduct = productsBySubject.get("math").get("Yearly").find(p => p.properties.title0 === "family")
              let mathFamilyPrice = (computePricingInfo(mathFamilyProduct, modifiedSettings).actualPrice/100.00).toFixed(2)
              saveAmount = (melaFamilyPrice - mathFamilyPrice).toFixed(0)
            }
            preferrPlanModalContent = createPreferredModalContent(
            `Select ${i18n.t('Math')} + Reading Plan`, // firstCta
            `Continue with ${selectedPlan.properties.display_name} plan`, //secondCta
            `By paying only ${appendCurrency(saveAmount,productsBySubject.get("mela").get(defaultShorterPlanDuration)[0])} extra for a year`, //subtitle
            `More than 80% users select`, //header1
            `${i18n.t('Math')} + Reading Plan`, //header2
            ((selectedPlan.feature_codes && selectedPlan.feature_codes[0] === 'math') || (selectedPlan.product_features && selectedPlan.product_features[0] == 'math')) ? GetAdditionalElaImage : GetAdditionalMathImage, //image1Path
            "Get additional", //image1Header
            "2000+", //image1Text
            ((selectedPlan.feature_codes && selectedPlan.feature_codes[0] === 'math') || (selectedPlan.product_features && selectedPlan.product_features[0] == 'math')) ? `Reading lessons` : `${i18n.t('Math')} Games`, //image1Subtitle
            "small" //image1Type
            )
          }
          if(initialDuration === defaultShorterPlanDuration && ((selectedPlan.feature_codes && selectedPlan.feature_codes.length != 2) || (selectedPlan.product_features && selectedPlan.product_features.length != 2))){ //Case-3 For Grade PreK-2, the user selects quarterly plan for Math or ELA instead of MELA Yearly Plan
            let melaYearlyProduct = productsBySubject.get("mela").get("Yearly")[0]
            let melaYearlyPrice = (computePricingInfo(melaYearlyProduct, modifiedSettings).actualPrice/100.00).toFixed(2)
            let selectedSubjectQuarterlyProduct = productsBySubject.get(selectedPlan.feature_codes ? selectedPlan.feature_codes[0] : selectedPlan.product_features[0].feature_code).get(defaultShorterPlanDuration)[0];
            let selectedSubjectQuarterlyPrice = (computePricingInfo(selectedSubjectQuarterlyProduct, modifiedSettings).actualPrice/100.00).toFixed(2)
            saveAmount = (selectedSubjectQuarterlyPrice*4 - melaYearlyPrice).toFixed(0)
            savePercentage = Math.abs(((melaYearlyPrice/24 - selectedSubjectQuarterlyPrice/4)/(selectedSubjectQuarterlyPrice/4))*100).toFixed(0)
            preferrPlanModalContent = createPreferredModalContent(
              `Select ${i18n.t('Math')} + Reading Plan`, // firstCta
              `Continue with ${defaultShorterPlanDuration} plan`, //secondCta
              `By paying only ${appendCurrency(saveAmount,productsBySubject.get("math").get(defaultShorterPlanDuration)[0])} extra for a year`, //subtitle
              `More than 80% users select`, //header1
              `${i18n.t('Math')} + Reading Plan`, //header2
              ((selectedPlan.feature_codes && selectedPlan.feature_codes[0] === 'math') || (selectedPlan.product_features && selectedPlan.product_features[0] == 'math')) ? GetAdditionalElaImage : GetAdditionalMathImage, //image1Path
              "Get additional", //image1Header
              "2000+", //image1Text
              ((selectedPlan.feature_codes && selectedPlan.feature_codes[0] === 'math') || (selectedPlan.product_features && selectedPlan.product_features[0] == 'math')) ? `Reading lessons` : `${i18n.t('Math')} Games`, //image1Subtitle
              "small", //image1Type
              SavePiggybankImage, //image2Path
              "SAVE", //image2Header
              `${savePercentage}%`, //image2Text
              `per subject`, //image2Subtitle
              "large", //image2Type
            )
          }
          if(initialDuration === defaultShorterPlanDuration && ((selectedPlan.feature_codes && selectedPlan.feature_codes.length == 2) || (selectedPlan.product_features && selectedPlan.product_features.length == 2))){ // Case-2  when User selects the Math + Reading Quarterly plan instead of Math + Reading Yearly plan
            let melaYearlyProduct = productsBySubject.get("mela").get("Yearly").find(p => p.properties.title0 === "Yearly")
            let melaYearlyPrice = (computePricingInfo(melaYearlyProduct, modifiedSettings).actualPrice/100.00).toFixed(2)
            let melaQuarterlyProduct = productsBySubject.get("mela").get(defaultShorterPlanDuration)[0];
            let melaQuarterlyPrice = (computePricingInfo(melaQuarterlyProduct, modifiedSettings).actualPrice/100.00).toFixed(2)
            let multiplyingFactor = defaultShorterPlanDuration.toLowerCase() == monthlyPlan ? 12 : 4;
            saveAmount = (melaQuarterlyPrice * multiplyingFactor - melaYearlyPrice).toFixed(0)
            preferrPlanModalContent = createPreferredModalContent(
              `Select Yearly Plan`, // firstCta
              `Continue with ${defaultShorterPlanDuration} plan`, //secondCta
              null, //subtitle
              `More than 80% users select`, //header1
              `yearly plan`, //header2
              SavePiggybankImage, //image1Path
              "SAVE", //image1Header
              `${appendCurrency(saveAmount,productsBySubject.get("math").get(defaultShorterPlanDuration)[0])}`, //image1Text
              'on yearly plan', //image1Subtitle
              "large" //image1Type
            )
          }
        }else{
          if (initialDuration === defaultShorterPlanDuration && ((selectedPlan.feature_codes && selectedPlan.feature_codes.length == 2) || (selectedPlan.product_features && selectedPlan.product_features.length == 2))) { // Case-4 when only math + reading(EXP_WEB_MELA_ONLY_PACKS pricing test) plans are visible to user when User selects the Math + Reading Quarterly plan instead of Math + Reading Yearly plan
            let melaYearlyProduct = productsBySubject.get("mela").get("Yearly").find(p => p.properties.title0 === "Yearly")
            let melaYearlyPrice = (computePricingInfo(melaYearlyProduct, modifiedSettings).actualPrice / 100.00).toFixed(2)
            let melaQuarterlyProduct = productsBySubject.get("mela").get(defaultShorterPlanDuration)[0];
            let melaQuarterlyPrice = (computePricingInfo(melaQuarterlyProduct, modifiedSettings).actualPrice / 100.00).toFixed(2)
            let multiplyingFactor = defaultShorterPlanDuration.toLowerCase() == monthlyPlan ? 12 : 4;
            saveAmount = (melaQuarterlyPrice * multiplyingFactor - melaYearlyPrice).toFixed(0)
            preferrPlanModalContent = createPreferredModalContent(
              `Select Yearly Plan`, // firstCta
              `Continue with ${defaultShorterPlanDuration} plan`, //secondCta
              null, //subtitle
              `More than 80% users select`, //header1
              `yearly plan`, //header2
              SavePiggybankImage, //image1Path
              "SAVE", //image1Header
              `${appendCurrency(saveAmount, productsBySubject.get("mela").get(defaultShorterPlanDuration)[0])}`, //image1Text
              'on yearly plan', //image1Subtitle
              "large" //image1Type
            )
          }
          else if(initialDuration === defaultShorterPlanDuration){ //Case-2 when User selects the Math Quarterly plan instead of Math Yearly plan
            let mathYearlyProduct = productsBySubject.get("math").get("Yearly").find(p => p.properties.title0 === "Yearly")
            let mathYearlyPrice = (computePricingInfo(mathYearlyProduct, modifiedSettings).actualPrice/100.00).toFixed(2)
            let mathQuarterlyProduct = productsBySubject.get("math").get(defaultShorterPlanDuration)[0];
            let mathQuarterlyPrice = (computePricingInfo(mathQuarterlyProduct, modifiedSettings).actualPrice/100.00).toFixed(2)
            saveAmount = (mathQuarterlyPrice*4 - mathYearlyPrice).toFixed(0)
            preferrPlanModalContent = createPreferredModalContent(
              `Select Yearly Plan`, // firstCta
              `Continue with ${defaultShorterPlanDuration} plan`, //secondCta
              null, //subtitle
              `More than 80% users select`, //header1
              `yearly plan`, //header2
              SavePiggybankImage, //image1Path
              "SAVE", //image1Header
              `${appendCurrency(saveAmount,productsBySubject.get("math").get(defaultShorterPlanDuration)[0])}`, //image1Text
              'on yearly plan', //image1Subtitle
              "large" //image1Type
            )
          }
        }
        setPreferrPlanModalContent(preferrPlanModalContent)
    }
  }, [selectedPlan,showDiscountChanges]);

  useEffect(()=>{
    GTMScript.initialise(modifiedSettings.gtm_tracking_id, "purchase/plans.js");
    if (typeof (dataLayer) != "undefined") {
      typeof trackToGtm!='undefined' && trackToGtm(dataLayer, 'payment page loaded', 'payment page loaded');
    }
    return ()=>{
      GTMScript.destroyGtm();
    }
  },[])

  useEffect(async ()=>{
    const stripePromise = await getStripePromise(modifiedSettings?.stripeKey);
    setStripe(stripePromise);
  },[])

  const createPreferredModalContent = (firstCta,secondCta,subtitle,header1,header2,image1Path,image1Header,image1Text,image1Subtitle,image1Type, image2Path=null,image2Header=null,image2Text=null,image2Subtitle=null,image2Type=null) => {
    return {firstCta,secondCta,subtitle,header1,header2,image1Path,image1Header,image1Text,image1Subtitle,image1Type, image2Path,image2Header,image2Text,image2Subtitle,image2Type}
  }

  const appendCurrency = (amount,product) => {
    return currencyCode[product.currency_code || 'USD'] + amount
  }
  const ModalCloseHandler = () => {
    modalHandler(false);
    // setShowMorePlans(true);
  }
  const updateInitialDuration = (event, val, doContinue) =>{
    if(!doContinue && sortedDurationList.length > 1 && (val===sortedDurationList[1] || (subjectsLength > 1 && activeFilterTab.id !== "mela")) && !modifiedSettings.hide_popup_of_preferred_plan) {
      modalHandler(true);
      setInitialDuration(val);
    } else {
      setShowMorePlans(false);
      setInitialDuration(val);
      setSelectedPlanName(val);
      trackAnalyticsEvent('Interacted All Plans Page', { 'Clicked On': 'Continue' });
      trackAnalyticsEvent('Viewed Purchase Page', window.purchasePageEventData);
      trackAnalyticsEvent('Visited Plan Purchase Combined Page', {
        'Plan Amount': selectedPlan['amount'],
        'Plan Type': frequencyLiterals[selectedPlan['access_duration']],
        'Stripe Payment Element Rendered': StripePaymentElementEnabled
          ? 'New Payment Element'
          : 'Old Credit Card Element',
      });

      if (!StripePaymentElementEnabled) {
        setTimeout(() => {
          const element = document.getElementById("scroll-elt");
          if (element){
            element.scrollTop = element.scrollHeight;
          }
        }, 1200)
      }
    }
    // if(showMorePlans && val===defaultShorterPlanDuration)
    //   return modalHandler(true);
  }

  const activePlanHandler = (val, plan) => {
    let mixpanelEventName = showMorePlans ? 'Interacted All Plans Page' : 'Interacted Plan Purchase Combined Page';
    if(plan.properties.payment_frequency === defaultShorterPlanDuration){
      trackAnalyticsEvent(mixpanelEventName, {'Interaction Details': "Clicked " + defaultShorterPlanDuration, 'Clicked On': defaultShorterPlanDuration});
    }else{
      if(plan.properties.title0 === 'family'){
        trackAnalyticsEvent(mixpanelEventName, {'Interaction Details': "Clicked Family Plan", 'Clicked On': 'Family card'});
      }else if(plan.properties.title0 === 'Yearly'){
        trackAnalyticsEvent(mixpanelEventName, {'Interaction Details': "Clicked Single Child Plan", 'Clicked On': 'Yearly card'});
      }else {
        trackAnalyticsEvent(mixpanelEventName, {'Interaction Details': "Clicked Single Child Plan", 'Clicked On': 'Monthly card'});
      }
    }
    setInitialDuration(val);
    selectedBoxHandler(products.get(val)); //
    localStorage.setItem('selectedProduct', JSON.stringify(plan));
    selectedPlanHandler(plan);
    setSelectedPlanName(plan.properties.title0);
  }

  const switchToYearlyPlan = (doContinue) => {
    if(doContinue) {
      modalHandler(false);
      updateInitialDuration(null, initialDuration, doContinue);
      trackAnalyticsEvent('Interacted All Plans Page',{'Interaction Details': "Continue", 'Clicked On': 'Continue'})
      return
    }else{
      trackAnalyticsEvent('Interacted All Plans Page',{'Interaction Details': "Changed Plan", 'Clicked On': 'Changed Plan'})
    }
    if(subjectsLength > 1) {
      filterTabHandler(filterTabList[0]);
    }
    selectedBoxHandler(products.get(DEFAULT_PLAN_DURATION));
    setInitialDuration(DEFAULT_PLAN_DURATION);
    updateInitialDuration(null, DEFAULT_PLAN_DURATION, true);
    modalHandler(false);
  }

  const paymentHandler = (subscribeData, params = {}) => {
    if(params.cardAdded){
      let eventSuffix = modifiedSettings.childAdded ? ' - Via Onboarding' : ' - Additional Purchase';
      if(restrictionInfoStore) {
        sendAnalytics("Clicked Payment Button");
      }
      sendAnalytics("Credit Card Added"+ eventSuffix);
    }else{
      sendAnalytics("Click Payment Button");
    }

    let options = { ...subscribeData,
      student_id: studentId,
      product_id: selectedPlan.id,
      from_trial: fromTrial
    }

    if (params.email_id) {
      options['email_id'] = params.email_id
    }
    if(modifiedSettings.coupon && modifiedSettings.coupon.stripe_id) {
      options['adc'] = modifiedSettings.coupon.stripe_id;
    }
    let eventObj = {
      'Product Name': subjectCodeMap[selectedPlan.properties.display_name],
      'Product Cost': amountInLocalCurrency(selectedPlan.amount, selectedPlan),
      'Product Duration': melaDurationMap[selectedPlan.access_duration],
      // [AI GENERATED CODE] Simplified: ELA is always enabled, so always use 'Mela 1.0'
      'Variation': 'Mela 1.0'
    }

    let mixPanelProperties = {};
    if(options?.subscribe_via_payment_request_button && options?.wallet_name && options?.wallet_name !== ''){
      const localStorageSelectedProduct = JSON.parse(localStorage.getItem('selectedProduct'));
      options = { ...options,
        product_id: localStorageSelectedProduct.id,
      }

      eventObj = {
        ...eventObj,
        'Product Name': subjectCodeMap[localStorageSelectedProduct.properties.display_name],
        'Product Cost': amountInLocalCurrency(localStorageSelectedProduct.amount, localStorageSelectedProduct),
        'Product Duration': melaDurationMap[localStorageSelectedProduct.access_duration],
        'Wallet': options.wallet_name,
      }
      mixPanelProperties = {
        ...mixPanelProperties,
        'Wallet': options.wallet_name,
      }
    }
    if(modifiedSettings.coupon && modifiedSettings?.coupon?.stripe_id==PARENTPTL_NEW_SIGNUPS_DISCOUNT_CODE && (!showDiscountChanges || selectedPlan.code!==modifiedSettings.eligible_product_codes[0])){
      delete options['adc']
    }
    Config.DataApi.subscribeProduct(options, function(data){
      if(data.error || !data.subscription || data.subscription.id == null){
        // [AI GENERATED CODE] Use shared helper for stripe error analytics
        const { stripeErrorEventProperties, paymentPageErrorEventProperties } = 
          buildStripeErrorPayloads(mixPanelProperties, data, selectedPlan.code);
        
        sendAnalytics("Stripe Error", stripeErrorEventProperties);
        sendAnalytics("Payment Page Error Viewed", paymentPageErrorEventProperties);
        that.setState({failureMessage: data.error});
        if (params.refreshPurchaseContext) {
          params.setButtonDisabled && params.setButtonDisabled(false)
          params.refreshPurchaseContext({error: data.error})
          
          // [AI GENERATED CODE] Use shared helper for purchaseFormSubmitErrorEvent
          const purchaseFormErrorEventProperties = buildPurchaseFormErrorPayload(data);
          
          params.purchaseFormSubmitErrorEvent && params.purchaseFormSubmitErrorEvent(purchaseFormErrorEventProperties)
        } else if(params.setError) {
          params.setButtonDisabled && params.setButtonDisabled(false)
          params.setError(data.error)
          params.scrollToTop && params.scrollToTop(500)
          
          // [AI GENERATED CODE] Build purchaseFormSubmitErrorEvent properties with conditional stripe error details
          const purchaseFormErrorEventProperties = {
            "Error Message" : data.error,
            "Error Step" : "subscribe_product_failed",
            "Error Message From Api" : data.error,
          };
          if (stripeError) {
            purchaseFormErrorEventProperties["Stripe Error"] = stripeError;
          }
          if (stripeErrorCode) {
            purchaseFormErrorEventProperties["Stripe Error Code"] = stripeErrorCode;
          }
          
          params.purchaseFormSubmitErrorEvent && params.purchaseFormSubmitErrorEvent(purchaseFormErrorEventProperties)
        } else {
          setError(data.error)
        }
      }else{
        sendAnalytics("Subscribe Product API Call Completed", eventObj);
        sendAnalytics("Product Purchased Frontend",{...eventObj, ...params.paymentElementProperties})
        if(upgradeAble) { //upgardeable
          let properties = {
            'Upgraded From Plan': currentPlan.display_name,
            'Upgraded to Plan': selectedPlan.display_name,
          }
          if(options.subscribe_via_payment_request_button && options.wallet_name && options.wallet_name !== '') {
            const localStorageSelectedProduct = JSON.parse(localStorage.getItem('selectedProduct'));
            properties = {
              ...properties,
              'Upgraded to Plan': localStorageSelectedProduct.display_name,
              'Wallet': options.wallet_name,
            }
          }
          sendAnalytics("Plan Upgraded", properties)
        }
        if(modifiedSettings.trialAvailable) {
          // [AI GENERATED CODE] Pass ltv_trial_value as ecomm_totalvalue to GTM
          const gtmEventData = data?.ltv_trial_value ? { ecomm_totalvalue: data.ltv_trial_value } : {};
          trackToGtm(window.dataLayer, 'Trial Start Web', 'Trial Start Web', gtmEventData);
        }
        trackServerEventToFacebook('transaction');
        trackTransactionEventToGtm('transaction');

        params.setButtonDisabled && params.setButtonDisabled(false)
        if(redirectUrl) {
          location.href = redirectUrl;
        } else if(data.redirect_url) {
          return location.href = data.redirect_url;
        }
        purchaseCompleteMethod(data.subscription);

      }
    }, paymentSuccessHandlerForSVTrial ?  true : false);
  }

  return (
    <>
      {
        showModal && <PreferredPlanModal
          switchToYearlyPlan={switchToYearlyPlan}
          ModalCloseHandler={ModalCloseHandler}
          subjectsLength={subjectsLength}
          filterTabList={filterTabList}
          savePercentage={preferredPlanSaving}
          preferrPlanModalContent={preferrPlanModalContent}
          defaultShorterPlanDuration={defaultShorterPlanDuration}
        />
      }
      <PlanContainer id="scroll-elt" showMorePlans={showMorePlans} isSemUserPage={modifiedSettings.is_sem_landing_user}>
        <TrialInfo settings={modifiedSettings} />
        {showMBG() && <MoneyBackWidgetContainer>
          <MoneyBackWidget bgColor='#212682' toolTipColor="#5659DD" fColor='#fff' iIconColor="#5659DD" textColor={true}/>
        </MoneyBackWidgetContainer> }
        <CSSTransition in={showMorePlans}
          timeout={300}
          classNames="filter-tab-anim"
          >
          <FilterTab userLandsOnAllPlansPage={userLandsOnAllPlansPage} activeFilterTab={activeFilterTab} filterTabList={filterTabList} filterTabHandler={filterTabHandler} showFilter={showFilter} subjectsLength={subjectsLength}/>
        </CSSTransition>
        <CSSTransition in={subjectsLength > 1 && showMorePlans} timeout={200} classNames="tile-slide">
          <div className={subjectsLength > 1 ?( userLandsOnAllPlansPage ? ""  : "product-plan-tile"): ""}>
          <CSSTransition in={false} timeout={1000}
          classNames="tile-slide">
            <GameCount activeFilterTab={activeFilterTab}/>
          </CSSTransition>
          
            <ProductPlan
              products={products}
              activeFilterTab={activeFilterTab}
              showMorePlans={showMorePlans}
              setShowMorePlans={setShowMorePlans}
              initialDuration={initialDuration}
              activePlanHandler={activePlanHandler}
              selectedPlan={selectedPlan}
              selectedBox={selectedBox}
              settings={modifiedSettings}
              properties={properties}
              subjectsLength={subjectsLength}
              sortedDurationList={sortedDurationList}
              savePercentage={savePercentage}
              percentOffAmount={percentOffAmount}
              showDiscountChanges={showDiscountChanges}
              timeLeft={timeLeft}
              stripePaymentElement={stripePaymentElement}
              updateProductPurchaseContext={updateProductPurchaseContext}
            />
          </div>
        </CSSTransition>

        {selectedPlan && <CSSTransition in={!showMorePlans} timeout={0} classNames="credit-slide" unmountOnExit mountOnEnter>
          <Wrapper>
            <CreditSectionHeading>Enter your payment details</CreditSectionHeading>
            {!percentOff && <SelectedPlanDetails>Unlimited access to {properties.display_name} at {amountInLocalCurrency(actualPrice, selectedPlan)} {modifiedSettings.showZipOnPurchase ? '*' : ''} (billed {melaDurationMap[access_duration]}). Renewed automatically</SelectedPlanDetails>}
            {!!percentOff && <SelectedPlanDetails>Unlimited access to {properties.display_name} at {amountInLocalCurrency(discountedPrice, selectedPlan)} (billed {melaDurationMap[access_duration]}). Renewed automatically</SelectedPlanDetails>}

            {!StripePaymentElementEnabled && stripe && (
              <Elements stripe={stripe} options={paymentRequestElementOptions}>
                <PaymentRequestButton
                  product={selectedPlan}
                  paymentHandler={paymentHandler}
                  settings={modifiedSettings}
                  skipSignUp={skipSignUp}
                  paymentSuccessHandlerForSVTrial={paymentSuccessHandlerForSVTrial}
                  fromT2PurchasePage ={false}
                  paymentRequest={paymentRequest}
                  setPaymentRequest={setPaymentRequest}
                />
              </Elements>
            )}

            {!StripePaymentElementEnabled && <CreditCardsContainer
              settings={modifiedSettings}
              selectedPlan={selectedPlan}
              paymentHandler={paymentHandler}
              error={error}
              setError={setError}
              skipSignUp = {skipSignUp}
              paymentSuccessHandlerForSVTrial={paymentSuccessHandlerForSVTrial}
              parentDobYear={parentDobYear}
              ptlParent={ptlParent}
              restrictionInfoStore={restrictionInfoStore}
              showDiscountChanges={showDiscountChanges}
            />}
            { StripePaymentElementEnabled && Object.keys(selectedPlan).length && 
              <ConfigurePayment
                source={PAYMENT_ELEMENT_SOURCE.product_purchase}
                product={selectedPlan}
                paymentHandler={paymentHandler}
              />
            }
          </Wrapper>
        </CSSTransition>}
        {showMorePlans && <PurchaseCta settings={modifiedSettings} clickHandler={updateInitialDuration} titleDuration={initialDuration} showDiscountChanges={showDiscountChanges} selectedPlan={selectedPlan}/>}
      </PlanContainer>
    </>
  );
}

function mapStateToProps(state) {
  return {
    settings: state.settings,
    studentId: state.studentId,
    purchaseComplete: state.purchaseComplete,
    restrictionInfoStore: state.restrictionInfoStore,
    sameSubjectUpgrade: state.sameSubjectUpgrade,
    upgradeAble: state.upgradeAble,
    subscriptionDetails: state.subscriptionDetails,
    productLists:state.products,
    stripePaymentElement: state.stripePaymentElement,
    currentPlan: state.currentPlan,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    purchaseCompleteMethod: (data) => dispatch({type: "SET_PURCHASE_COMPLETE", payload: data}),
    updateProductPurchaseContext: (data) => dispatch({type: "UPDATE_PRODUCT_PURCHASE_CONTEXT", payload: data}),
  }
}

export default connect(mapStateToProps, mapDispatchToProps, Plans);

export const Wrapper = Styled.div`
  @media (max-width: ${breakpoints.xl}px) {
    margin-bottom: 14rem; ui fix in ipad portrait
  }
  @media (max-width: ${breakpoints.sm}px) {
    margin-bottom: 8rem; // ui fix in portrait mode for iphone
  }
  @media (min-width: ${breakpoints.lgCommonBreakpoint - 1}px) and (max-width: ${breakpoints.xl}px) and (orientation: landscape){
    margin-bottom: 8rem; // fix for distorted UI in ipad
  }
  form {
    margin: 0 auto;
    width:47rem;
    @media ${device.PhoneLargeScreen} {
      width: 37rem;
      padding-bottom: 5rem;
    }
    @media ${device.Phone} {
      width: 34rem;
      padding-bottom: 10rem;
    }
  }

`;

export const CreditSectionHeading = Styled.h3`
  margin-top: 2rem;
  ${fontQuicksand(2, 2.6, 7)};
  @media ${device.PhoneLargeScreen} {
    margin-top: 2rem;
    ${fontQuicksand(1.4, 2, 7)};
  }
  @media ${device.Phone} {
    margin-top: 2rem;
    ${fontQuicksand(1.4, 2, 7)};
  }
`;

export const SelectedPlanDetails = Styled.p`
  width: 45rem;
  margin: 0.4rem auto 1rem;
  ${fontQuicksand(1.4, 1.8, 5)};
  @media ${device.PhoneLargeScreen} {
    margin-bottom: 1rem;
    width: 37rem;
    ${fontQuicksand(1.2, 1.6, 5)};
  }
  @media ${device.Phone} {
    margin-bottom: 1rem;
    width: 85%;
    ${fontQuicksand(1.2, 1.6, 5)};
  }
`;

export const PlanContainer = Styled.div`
  overflow: scroll;
  scroll-behavior: smooth;
  height: ${props => props.showMorePlans ? `100%` : `calc(100vh - 170px)`};
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
  scrollbar-width: none;
  &::-webkit-scrollbar {
      display: none;
  }
  @media ${device.Phone} {
    overflow: scroll; // fix for no auto scroll
    height: ${props => props.isSemUserPage ? props.showMorePlans ? `100%` : `calc(100vh + 120px)` : props.showMorePlans ? `100%` : `calc(100vh)`};
  }
  @media ${device.PhoneLandscape} {
    overflow: scroll; // fix for no auto scroll
    height: ${props => props.isSemUserPage ? props.showMorePlans ? `100%` : `calc(100vh + 120px)` : props.showMorePlans ? `100%` : `calc(100vh - 125px)`};
  }
  @media ${device.PhoneLargeScreen} {
    overflow: scroll // fix for no auto scroll
    height: ${props => props.isSemUserPage ? props.showMorePlans ? `100%` : `calc(100vh + 120px)` : props.showMorePlans ? `100%` : `calc(100vh - 125px)`};
  }
  @media (min-width: ${breakpoints.md}px) and (max-width: ${breakpoints.xl}px) { // fix for distorted UI in ipad
    height: ${props => props.isSemUserPage ? props.showMorePlans ? `100%` : `calc(100vh + 120px)` : props.showMorePlans ? `100%` : `calc(100vh - 70px)`};
  }
`;

export const MoneyBackWidgetContainer = Styled.div`
  @media ${device.Desktop}{
    margin-bottom: 4rem;
  }
`

export const SummerImg = Styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 3.92rem;
  height: 4.42rem;
  @media (min-width: ${breakpoints.md}px){
    width: 10.9rem;
    height: 12.3rem;
  }
  @media ${device.Desktop}{
    width: 13.62rem;
    height: 15.37rem;
  }
  >img{
    width: 100%;
    height: 100%;
  }
`